/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const CheckIcon = /*#__PURE__*/ createSvgIcon(
  'CheckIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M8.104 12.313l6.23-6.23a.73.73 0 011.063 0 .73.73 0 01.007 1.058l-6.758 6.776a.73.73 0 01-1.063 0l-2.979-2.98a.73.73 0 010-1.062.733.733 0 011.063 0l2.437 2.438z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default CheckIcon;
